export default "__VITE_ASSET__lwQcxvlV__"